/**
 * Utility functions for Countdown component
 */

/**
 * Format number with leading zeros
 */
export function formatNumber(num: number, digits: number = 2): string {
  return num.toString().padStart(digits, '0');
}

/**
 * Helper function to get label text
 * Returns custom label or falls back to default
 */
export function getLabelText(
  unit: 'days' | 'hours' | 'minutes' | 'seconds',
  type: 'default' | 'short',
  labelDays?: string,
  labelHours?: string,
  labelMinutes?: string,
  labelSeconds?: string,
) {
  if (type === 'short') {
    return { days: 'D', hours: 'H', minutes: 'M', seconds: 'S' }[unit];
  }

  const defaultLabels = { days: 'Days', hours: 'Hours', minutes: 'Minutes', seconds: 'Seconds' };
  const customLabels = {
    days: labelDays,
    hours: labelHours,
    minutes: labelMinutes,
    seconds: labelSeconds,
  };

  const customLabel = customLabels[unit];
  const isEmptyOrWhitespace = !customLabel || customLabel.trim() === '';

  return isEmptyOrWhitespace ? defaultLabels[unit] : customLabel;
}
